import { PageHero } from "@/components/PageHero";
import { FAQAccordion } from "@/components/FAQAccordion";
import { QuoteCTA } from "@/components/QuoteCTA";
import { useSiteContent } from "@/context/ContentContext";

export default function FAQ() {
  const { faqs } = useSiteContent();
  return (
    <>
      <PageHero kicker="FAQ" title="Frequently Asked Questions"
        text="Answers about parts, fitment, enquiries, shipping, orders and support. Search or browse below."
        image="https://images.unsplash.com/photo-1583198432859-635beb4e8600?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" />
      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <FAQAccordion faqs={faqs} searchable />
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
